import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Button } from '@tq/ui-components';

import { useEditingReviewState } from '../../hooks';
import { ReviewResponse } from '../../types';

export type ReviewCardFooterProps = {
  idReference: ReviewResponse;
  isLoading: boolean;
};

export const ReviewCardFooter: React.FC<ReviewCardFooterProps> = ({
  idReference,
  isLoading,
}) => {
  const { t } = useTranslation('dfi_report_review');

  const [isEditing, setIsEditing] = useEditingReviewState(idReference);

  return (
    <>
      {isEditing ? (
        <Flex justifyContent='flex-end'>
          <Flex gridGap={5}>
            <Button
              data-testid={`${idReference}-cancel-button`}
              fontSize='sm'
              variant='secondary'
              disabled={isLoading}
              w={{ base: '100%', lg: 'unset' }}
              onClick={() => setIsEditing(false)}
            >
              {t('cancel', 'Cancel')}
            </Button>
            <Button
              data-testid={`${idReference}-save-button`}
              fontSize='sm'
              variant='primary'
              type='submit'
              disabled={isLoading}
              form={`dfi-review-${idReference}-form`}
              w={{ base: '100%', lg: 'unset' }}
            >
              {t('save', 'Save')}
            </Button>
          </Flex>
        </Flex>
      ) : (
        <Flex justifyContent='flex-end'>
          <Button
            data-testid={`${idReference}-edit-button`}
            fontSize='sm'
            variant='secondary'
            w={{ base: '100%', lg: 'unset' }}
            onClick={() => setIsEditing(true)}
          >
            {t('edit', 'Edit')}
          </Button>
        </Flex>
      )}
    </>
  );
};
